/**
 * @file 用于处理 { a ? b : c } 类似有 v-if
 */

import type { ReactElement } from 'react';
import React from 'react';

interface Props {
  show: boolean;
  children: ReactElement;
}

const IfRender: React.FC<Props> = ({ show = true, children }) => {
  return <>{show && children}</>;
};
export default IfRender;
